const payWall = document.querySelector('.pay-wall');

if (payWall) setTimeout(() => {
  payWall.classList.add('show');
  document.body.classList.add('overflow-hidden');
}, 4000);
